"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPrice = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const text_styles_1 = require("@/components/common/text/text.styles");
require("@/components/common");
/**
 * mm-product-price
 * 상품 가격 표시. 정가(취소선)·판매가·할인 표기를 한 줄로 보여준다.
 * size는 mm-paragraph의 size와 동일한 의미를 갖는다.
 */
let ProductPrice = class ProductPrice extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.size = 'medium';
        this.price = '';
        this.originalPrice = '';
        this.discount = '';
    }
    render() {
        return (0, lit_1.html) `
      ${this.renderOriginalPrice()}${this.renderPrice()}${this.renderDiscount()}
    `;
    }
    get textSize() {
        return text_styles_1.paragraphSizeToTextSize[this.size];
    }
    renderOriginalPrice() {
        if (!this.originalPrice)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <del>
        <mm-text size=${this.textSize} color="light">${this.originalPrice}</mm-text>
      </del>
    `;
    }
    renderPrice() {
        if (!this.originalPrice) {
            return (0, lit_1.html) `
        <mm-text size=${this.textSize} weight="bold">${this.price}</mm-text>
      `;
        }
        return (0, lit_1.html) `
      <ins>
        <mm-text size=${this.textSize} weight="bold">${this.price}</mm-text>
      </ins>
    `;
    }
    renderDiscount() {
        if (!this.discount)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-text size=${this.textSize}>(${this.discount})</mm-text>
    `;
    }
};
ProductPrice.styles = (0, lit_1.css) `
    :host {
      display: flex;
      align-items: baseline;
      gap: var(--space-2);
    }

    del {
      text-decoration: line-through;
    }

    ins {
      text-decoration: none;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ProductPrice.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ProductPrice.prototype, "price", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'original-price' })
], ProductPrice.prototype, "originalPrice", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ProductPrice.prototype, "discount", void 0);
ProductPrice = __decorate([
    (0, decorators_js_1.customElement)('mm-product-price')
], ProductPrice);
exports.ProductPrice = ProductPrice;
//# sourceMappingURL=data:application/json;base64,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